import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const usePesquisaMotivoCompra = ({ formikRef }) => {
  const pesquisaMotivoCompraSelect = useSelect("pesquisaMotivosCompra");
  const [pesquisaMotivoCompra, setPesquisaMotivoCompra] = useState(0);
  const [fila, setFila] = useState(null);

  const [pesquisaMotivosCompra, setPesquisaMotivosCompra] = useState([]);

  useEffect(() => {
    const fetchPesquisaMotivosCompra = async () => {
      const motivosCompra = [];
      await db.pesquisaMotivoCompra.each((motivo) => {
        motivosCompra.push(motivo);
      });
      setPesquisaMotivosCompra(motivosCompra);
    };

    fetchPesquisaMotivosCompra();
  }, []);

  const optionPesquisaMotivoCompra = useMemo(
    () =>
      prepareForOptions(
        pesquisaMotivosCompra?.filter((e) => e.ativo),
        ["nome"],
        "id"
      ),
    [pesquisaMotivosCompra]
  );

  useEffect(() => {
    if (fila && pesquisaMotivosCompra && pesquisaMotivosCompra.length > 0) {
      setPesquisaMotivoCompraSelect(fila);
    }
  }, [fila, pesquisaMotivosCompra]);

  function setPesquisaMotivoCompraSelect(value) {
    if (pesquisaMotivosCompra && pesquisaMotivosCompra.length > 0) {
      const optionCentro = (pesquisaMotivosCompra || []).find((opt) => opt.id == value);

      if (optionCentro) {
        onChangePesquisaMotivoCompra({
          label: optionCentro.nome,
          value: optionCentro.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaMotivoCompra(e) {
    pesquisaMotivoCompraSelect.upDateValue(e.value);
    pesquisaMotivoCompraSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("pesquisaMotivoCompraId", e.value);
      setTimeout(() => formikInstance.setFieldTouched("pesquisaMotivoCompraId", true));
    }

    setPesquisaMotivoCompra(e.value);
  }

  return {
    pesquisaMotivoCompra,
    optionPesquisaMotivoCompra,
    onChangePesquisaMotivoCompra,
    pesquisaMotivosCompra,
    pesquisaMotivoCompraSelect,
    setPesquisaMotivoCompra,
    setPesquisaMotivoCompraSelect,
  };
};

export default usePesquisaMotivoCompra;
